var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubstitute = function SvgSubstitute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1FA300",
    d: "M5.04 9.807 2.202 6.903a.714.714 0 0 1-.057-.932l.057-.066L5.04 3l1.022.998-1.697 1.74 10.472-.001v1.428L4.46 7.166 6.061 8.81l-1.022.998Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C00",
    d: "m14.797 16.614 2.836-2.904a.714.714 0 0 0 .058-.931l-.058-.067-2.836-2.905-1.022.998 1.697 1.74L5 12.543v1.429h10.377l-1.602 1.643 1.022.998Z"
  }))));
};
export default SvgSubstitute;